'use client';

import React from 'react';

import style from './NotFound.module.scss';
import Link from 'next/link';
import {Route} from '@constants/appRoutes';
import '../../app/globals.scss';

export function NotFound() {
  return (
    <div className={style.container} data-test-id='notFound'>
      <h1>404 - Page Not Found</h1>
      <h3>Sorry, the page you are looking for does not exist.</h3>
      <p>
        <Link href={Route.HOME()}>Go back to Homepage</Link>
      </p>
    </div>
  );
}
